// Update contents object below

const contents = {
  header: 'Intel Corporation',
  video:
    'https://player.vimeo.com/video/915198468?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Intel - Eigen',
  title: 'Forging the future alongside AI',
  copy: 'Even the most experienced workforce can’t catch every defect off the line. But for the team at Southern Fabricators Inc, the future of smart manufacturing is already underway. See how Intel’s Core™ processors and OpenVINO™ platform in conjunction with Eigen’s agile, intuitive Computer Vision are revolutionizing efficiency and quality across the whole business.',
  url: 'https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/',
  button: 'More Intel Stories'
};

export default contents;
